import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  decryptRequest,
  encryptRequest,
} from "../../../utils/encryptdecryptrequest";
import { axios_instance } from "../../../api/axios_instance";

const CaseReversalPanel = () => {
  const [state, setState] = useState({ loanId: "", disableDeleteBtn: false });
  const deleteCase = async (e) => {
    e.preventDefault();

    toast.dismiss();
    try {
      if (!state.loanId)
        return toast.error("Please enter loan id.", { theme: "colored" });
      setState({ ...state, disableDeleteBtn: true });

      let reqData = encryptRequest({ finance_lead_id: state.loanId });
      let result = await axios_instance({
        url: "/paymentadminpanel/caseReversalEligibility",
        method: "POST",
        data: { reqData },
      });
      let resData = decryptRequest(result.data.resData);

      if (result.status === 200) {
        if (
          window.confirm(
            `Are you sure you want to permanently delete loanId-${state.loanId} from PaymentBox?`
          )
        ) {
          reqData = encryptRequest({
            finance_lead_id: state.loanId,
            disbursement_id: resData.disbursement_id,
            pay_count: resData.pay_count,
          });
          result = await axios_instance({
            url: "/paymentadminpanel/deleteCase",
            method: "DELETE",
            data: { reqData },
          });
          resData = decryptRequest(result.data.resData);

          if (result.status === 200) {
            toast.success(resData.msg, { theme: "colored" });
            setState((prevState) => ({ ...prevState, loanId: "" }));
          }
        }
      }
    } catch (error) {
      const msg = error?.response?.data?.message
        ? error.response.data.message
        : "Something went wrong";
      toast.error(msg, { theme: "colored" });
    }
    setState((prevState) => ({ ...prevState, disableDeleteBtn: false }));
  };
  return (
    <div
      role="tabpanel"
      className="tab-pane fade in active"
      id="tab-case-reversal"
    >
      <div className="panel panel-default">
        <div className="panel-heading">Remove/Delete Case</div>
        <div className="panel-body">
          <form
            name="case-reversal-form"
            id="case-reversal-form"
            autoComplete="off"
          >
            <div className="row">
              <div className="form-group col-md-3">
                <label htmlFor="name">Loan Id</label>
              </div>
              <div
                className="form-group col-md-3"
                style={{ paddingRight: "0px" }}
              >
                <input
                  required="required"
                  type="number"
                  name="loan_id"
                  id="loan_id"
                  className="form-control case-reversal-fields"
                  autoComplete="off"
                  placeholder="Loan Id"
                  value={state.loanId}
                  onChange={(e) =>
                    setState({ ...state, loanId: e.target.value })
                  }
                />
              </div>
              <div
                className="form-group col-md-3"
                style={{
                  padding: "0px",
                  textAlign: "left",
                  marginLeft: "-2px",
                }}
              >
                <button
                  id="tab-verify-button"
                  data-form="case-reversal-form"
                  className="btn btn-success"
                  onClick={(e) => deleteCase(e)}
                  disabled={state.disableDeleteBtn}
                >
                  Delete Case
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CaseReversalPanel;
